import { AbsenceTypes } from '@/types/Absence/AbsenceTypes';
import React from 'react';
import { BsAirplane, BsHospital } from 'react-icons/bs';

type AbsenceIconType = {
  type: AbsenceTypes;
  size?: number;
};

export const AbsenceIcon = ({ type, size = 18 }: AbsenceIconType) => {
  switch (type) {
    case 'vacation':
      return <BsAirplane size={size} />;
    case 'sick':
      return <BsHospital size={size} />;
    default:
      return <BsAirplane size={size} />;
  }
};
